module.exports = {"410728001":"蒲西街道","410728002":"蒲东街道","410728003":"南蒲街道","410728004":"蒲北街道","410728005":"魏庄街道","410728101":"丁栾镇","410728102":"樊相镇","410728104":"恼里镇","410728105":"常村镇","410728106":"赵堤镇","410728107":"孟岗镇","410728108":"满村镇","410728109":"苗寨镇","410728110":"张三寨镇","410728111":"方里镇","410728112":"佘家镇","410728202":"芦岗乡","410728206":"武邱乡","410728460":"河南长垣起重工业园区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410728.json
// module id = 1591
// module chunks = 0